import { v4 as uuid } from 'uuid';

const AANKOOP_TEXTS: ReadonlyArray<string> = [
  'Minimum aankoopbudget: €250.000',
  'Aankoopintentie binnen 3 maanden',
  'Woonwens bevindt zich binnen het werkgebied',
];

const VERKOOP_TEXTS: ReadonlyArray<string> = [
  'Verkoopintentie binnen 3 maanden',
  'Huis bevindt zich binnen het werkgebied',
];

const HYPOTHEEK_TEXTS: ReadonlyArray<string> = [
  'Aankoopintentie binnen 3 maanden',
  'Voldoende financiële draagkracht',
  'Geen problematische schulden',
  'Geen negatieve BKR registratie',
];

const SERVICE_DEFAULT_TEXTS: Record<string, ReadonlyArray<string>> = {
  'lfs-e0bc6a25-af13-43e4-b291-2f8c9682b90a': AANKOOP_TEXTS,
  'lfs-15784374-0702-442e-ad42-98fd092db88c': AANKOOP_TEXTS,
  'lfs-6ded0299-0d05-4f1b-a0dc-9de34c460f06': VERKOOP_TEXTS,
  'lfs-26c500e5-f144-45c9-8564-47cf3ce1206d': VERKOOP_TEXTS,
  'lfs-a35d9d1b-d925-465c-babb-95d5be5ce336': HYPOTHEEK_TEXTS,
};

/**
 * Returns default criteria for a service, formatted as LFA_Service_Criterion_V2 rows.
 * Each call generates fresh UUIDs. Returns an empty array when the service has no known defaults.
 */
const getDefaultCriteria = (
  serviceId: string,
): Array<{
  __typename: 'LFA_Service_Criterion_V2';
  id: string;
  text: string;
}> =>
  (SERVICE_DEFAULT_TEXTS[serviceId] ?? []).map(text => ({
    __typename: 'LFA_Service_Criterion_V2' as const,
    id: uuid(),
    text,
  }));

export default getDefaultCriteria;
